<template>
  <div class="mt-1">
    <a v-if="url && isImage" :href="url" target="_blank" rel="noopener" class="block">
      <img :src="url" :alt="attachment.fileName" class="rounded border border-secondary-200 max-h-64 max-w-full object-contain bg-white" />
    </a>
    <a v-else-if="url" :href="url" target="_blank" rel="noopener" class="inline-flex items-center gap-2 rounded border border-secondary-200 bg-white px-3 py-2 text-sm text-securdia-blue hover:underline">
      <BaseIcon icon="paperclip" />{{ attachment.fileName }}
    </a>
    <div v-else-if="failed" class="inline-flex items-center gap-2 rounded border border-secondary-200 bg-secondary-50 px-3 py-2 text-xs text-secondary-500" :title="failed">
      <BaseIcon icon="image" />{{ attachment.fileName }} · {{ $t("securone.chat.image_unavailable") }}
    </div>
    <div v-else class="inline-flex items-center gap-2 rounded border border-secondary-200 bg-secondary-50 px-3 py-2 text-xs text-secondary-500">
      <BaseIcon icon="image" />{{ $t("securone.common.loading") }}
    </div>
  </div>
</template>

<script>
import api from "../securone.api";

// A chat photo. The server hands out a short-lived signed URL for the file in
// the app's bucket; the image is shown inline and opens full size in a new tab.
export default {
  name: "ChatAttachment",
  props: {
    eventId: { type: String, required: true },
    messageId: { type: String, required: true },
    attachment: { type: Object, required: true },
  },
  data() {
    return { url: null, failed: null };
  },
  computed: {
    isImage() {
      return /^image\//.test(this.attachment.mimeType || "") || this.attachment.kind === "photo";
    },
  },
  async created() {
    try {
      const file = await api.messageAttachment(this.eventId, this.messageId);
      this.url = file.url;
    } catch (error) {
      const data = error && error.response && error.response.data;
      this.failed = (data && (data.message || data.errorId)) || "unavailable";
    }
  },
};
</script>
